module.exports = __webpack_public_path__ + "static/media/Patient.b03b24ad.PNG";